import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./core/guard/auth.guard";
import { AppRoutes } from "./routes/routes.enum";
import { PagesRoute } from "./pages/src/app/ui/routes/routes.enum";
import { LoginComponent } from "./pages/login-page/ui/login.component";
import { AdminDashboardComponent } from "./pages/admin-dashboard/ui/admin-dashboard.component";
import { SignupComponent } from "./pages/signup-page/ui/signup.component";
import { AuthGuarder } from "./pages/login-page/data-access/auth.guard";

export const routes: Routes = [
  // {
  //   path: AppRoutes.Login,
  //   // loadChildren: () => import('./').then(m => m.LoginModule),
  // },
  {
    path: "",
    pathMatch: "full",
    redirectTo: `/${AppRoutes.App}/${PagesRoute.HomePage}`, // Redirect to the home page
  },
  {
    path: PagesRoute.LoginPage,
    pathMatch: 'full',
    component: LoginComponent
  },
  {
    path: PagesRoute.AdminDashboard,
    pathMatch: 'full',
    component: AdminDashboardComponent,
    canActivate: [AuthGuarder]
  },
  {
    path: PagesRoute.Signup,
    pathMatch: 'full',
    component: SignupComponent
  },
  {
    path: AppRoutes.App,
    loadChildren: () =>
      import("./pages/src/app/ui/pages.module").then((m) => m.PagesModule),
  },
  {
    path: "**",
    pathMatch: 'full',
    redirectTo: PagesRoute.PageNotFound,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
